module.exports = __webpack_public_path__ + "images/life.c01f46f7b9e937300a2f422276c3cdfa.svg";